module.exports = __webpack_public_path__ + "assets/img/send-white.051e0906.svg";